document.addEventListener('DOMContentLoaded', function () {
  // Check if we're on the cart page
  const cartItems = document.querySelectorAll('.cart-item[data-product-id]');

  if (cartItems.length > 0) {
    // Collect product IDs from cart items
    const productIds = [];
    const variantIds = [];

    cartItems.forEach((item) => {
      const variantId = item.getAttribute('data-variant-id');
      if (variantId) {
        // Format the variant ID as required by the API
        productIds.push(`gid://shopify/ProductVariant/${variantId}`);
        variantIds.push(variantId);
      }
    });

    // If we have product IDs, fetch inventory data
    if (productIds.length > 0) {
      const nearestStore = JSON.parse(sessionStorage.getItem('nearestStore') || '{}');

      // Only proceed if we have a store location
      if (nearestStore && nearestStore.location_id) {
        // Check if handleFetchInventoryProducts function exists
        if (typeof fetchInventoryProducts === 'function') {
          fetchInventoryProducts(productIds, nearestStore.location_id)
            .then((inventoryData) => {
              // Update cart items with inventory information
              if (inventoryData && inventoryData.length > 0) {
                updateCartItemsInventory(inventoryData, variantIds);
              }
            })
            .catch((error) => {
              console.error('Error fetching inventory data:', error);
            });
        }
      } else {
        console.log('No nearest store found in session storage');
      }
    }
  }
});

/**
 * Updates the cart items with inventory information
 * @param {Array} inventoryData - Array of inventory data for products
 * @param {Array} variantIds - Array of variant IDs corresponding to cart items
 */
function updateCartItemsInventory(inventoryData, variantIds) {
  // Map inventory data to variant IDs for easy lookup
  const inventoryMap = {};

  inventoryData.forEach((item) => {
    // Extract the numeric ID from the variant ID (remove the "gid://shopify/ProductVariant/" prefix)
    const idParts = item.variantId.split('/');
    const numericId = idParts[idParts.length - 1];
    inventoryMap[numericId] = item;
  });

  // Update each cart item with its inventory status
  const cartItems = document.querySelectorAll('.cart-item[data-variant-id]');

  cartItems.forEach((item) => {
    const variantId = item.getAttribute('data-variant-id');
    const inventoryInfo = inventoryMap[variantId];

    if (inventoryInfo) {
      // Find the basket-item element within this cart item
      const basketItem = item.querySelector('.basket-item');

      if (basketItem) {
        // Update content based on inventory status
        if (!inventoryInfo.tracked || (inventoryInfo.variantStock > 0 && inventoryInfo.tracked)) {
          basketItem.classList.add('in-stock');
        } else {
          basketItem.classList.add('hidden');
        }
      }
    }
  });
}
